
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entry",
      function () {
        return require("private-next-pages/entry.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/entry"])
      });
    }
  